import { useContext } from 'react';

import { CreateWebhookContext } from './CreateWebhookContext';
import { CreateWebhookFormSteps } from './CreateWebhookModalContent';
import { FormikWebhookConfigureDestination } from './FormikWebhookConfigureDestination';
import { FormikWebhookDesideTriggers } from './FormikWebhookDesideTriggers';
import { FormikWebhookSelectEvents } from './FormikWebhookSelectEvents';

export const FormikWebhookFormSteps = () => {
    const { activeFormStep } = useContext(CreateWebhookContext);

    switch (activeFormStep) {
        case CreateWebhookFormSteps.SELECT_EVENTS:
            return <FormikWebhookSelectEvents />;
        case CreateWebhookFormSteps.DECIDE_TRIGGERS:
            return <FormikWebhookDesideTriggers />;
        case CreateWebhookFormSteps.CONFIGURE_DESTINATION:
            return <FormikWebhookConfigureDestination />;
    }
};
